<template>
  <b-row class="p-3 sg-rounded-container">
    <!-- dekstop -->
    <b-col class="d-none d-sm-block">
      <!-- header -->
      <b-row class="center-base between">
        <b-col cols="4">
          <span style="font-size: 1.5em; font-weight: 700; color: #233c7c;">
            Passenger {{ index + 1 }}
          </span>
        </b-col>
        <b-col cols="2" class="text-right">
          <font-awesome-icon icon="angle-up" style="font-size: 2em; font-weight: 700; color: #233c7c;" />
        </b-col>
      </b-row>

      <hr style="border-top: 2px solid #dddddd;">

      <!-- row 1 -->
      <b-row class="mt-3">
        <b-col cols="3">
          <b-form-input
            v-model="order_paxs.first_name"
            id="input-first_name"
            placeholder="First Name"
            type="text"
          />
        </b-col>
        <b-col cols="3">
          <b-form-input
            v-model="order_paxs.last_name"
            id="input-last_name"
            placeholder="Last Name"
            type="text"
          />
        </b-col>
        <b-col cols="3">
          <b-form-select
            v-model="order_paxs.gender"
            id="input-gender"
            :options="gender_options"
          />
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col>
          <i style="color: #f27137;">We recommend you to fill your passenger info.</i>
        </b-col>
      </b-row>

      <!-- row 2 -->
      <b-row class="mt-3">
        <b-col cols="6">
          <b-form-file
            id="input-passport-file"
            placeholder="Choose a file..."
            drop-placeholder="Drop file here..."
            :name="`pax_${index}_passport`"
            @change="appendFormData"
          />
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col>
          <i style="color: #f27137;">If there is a loss of goods / passport, as much as possible our Partners (Guiders) will assist the process of making a report to the local police in the country you are visiting and will help make the SPLP (Surat Perjalanan Laksana Passpor) at the Indonesian Embassy.</i>
        </b-col>
      </b-row>
    </b-col>

    <!-- mobile -->
    <b-col class="d-block d-sm-none">
      <!-- header -->
      <b-row class="center-base between">
        <b-col cols="6">
          <span style="font-size: 1.2em; font-weight: 700; color: #233c7c;">
            Passenger {{ index + 1 }}
          </span>
        </b-col>
        <b-col cols="2" class="text-right">
          <font-awesome-icon icon="angle-up" style="font-size: 1.5em; font-weight: 700; color: #233c7c;" />
        </b-col>
      </b-row>

      <hr style="border-top: 2px solid #dddddd;">

      <!-- row 1 -->
      <b-row class="mt-3">
        <b-col cols="6">
          <b-form-input
            v-model="order_paxs.first_name"
            id="input-first_name"
            placeholder="First Name"
            type="text"
          />
        </b-col>
        <b-col cols="6">
          <b-form-input
            v-model="order_paxs.last_name"
            id="input-last_name"
            placeholder="Last Name"
            type="text"
          />
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col cols="6">
          <b-form-select
            v-model="order_paxs.gender"
            id="input-gender"
            :options="gender_options"
          />
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col>
          <i style="color: #f27137;">We recommend you to fill your passenger info.</i>
        </b-col>
      </b-row>

      <!-- row 2 -->
      <b-row class="mt-3">
        <b-col>
          <b-form-file
            id="input-passport-file"
            placeholder="Choose a file..."
            drop-placeholder="Drop file here..."
            :name="`pax_${index}_passport`"
            @change="appendFormData"
          />
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col>
          <i style="color: #f27137;">If there is a loss of goods / passport, as much as possible our Partners (Guiders) will assist the process of making a report to the local police in the country you are visiting and will help make the SPLP (Surat Perjalanan Laksana Passpor) at the Indonesian Embassy.</i>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<script>
// external dependencies

// custom component

// api call

export default {
  name: 'Order_PassengerDetail',
  props: ['order_paxs', 'index'],
  components: {
  },
  data () {
    return {
      gender_options: [
        { value: null, text: 'Gender', disabled: true },
        { value: 'male', text: 'Male' },
        { value: 'female', text: 'Female' }
      ]
    }
  },
  methods: {
    // PREREQUISITES
    appendFormData: function (e) {
      this.$emit('appendFormData', e)
    }
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Order/PassengerDetail/PassengerDetail.vue